import connect from './connect';

export { PaymentScreen } from './PaymentScreen';

export default connect;
